/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* STICKY ATC */

/* make it sticky */

const stickyAtc = document.querySelector('.sticky-atc');
const productFormAddButton = document.querySelector('.pdp-purchase-form .product-form__add-button');

function handleScroll() {
  if (!stickyAtc || !productFormAddButton) {
    return;
  }

  const rect = productFormAddButton.getBoundingClientRect();
  if (rect.top < 0) {
    stickyAtc.classList.add('visible');
  } else {
    stickyAtc.classList.remove('visible');
  }
}

if (stickyAtc && productFormAddButton) {
  window.addEventListener('scroll', handleScroll);
  handleScroll();
}

/* updating prices */

const sourceElement = document.querySelector('.pdp-price-list');
const targetElement = document.querySelector('.sticky-atc__price');

function updateTargetPrices() {
  const sourceFirstPrice = sourceElement.querySelector('.firstPriceValue');
  const sourceSecondPrice = sourceElement.querySelector('.secondPriceValue');
  const sourcePrimaryPrice = sourceElement.querySelector('.pdp-current-price, .price:not(.price--compare)');

  const targetFirstPrice = targetElement.querySelector('.firstPriceValue');
  const targetSecondPrice = targetElement.querySelector('.secondPriceValue');
  const targetPrimaryPrice = targetElement.querySelector('.price');

  if (sourceFirstPrice && targetFirstPrice) {
    targetFirstPrice.textContent = sourceFirstPrice.textContent;
  }
  if (sourceSecondPrice && targetSecondPrice) {
    targetSecondPrice.textContent = sourceSecondPrice.textContent;
  }
  if (!sourceFirstPrice && sourcePrimaryPrice && targetPrimaryPrice) {
    targetPrimaryPrice.textContent = sourcePrimaryPrice.textContent;
  }
}

if (sourceElement && targetElement) {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList' || mutation.type === 'subtree') {
        updateTargetPrices();
      }
    });
  });

  const config = { childList: true, subtree: true };

  observer.observe(sourceElement, config);
  updateTargetPrices();
}

(function() {
  const nativeWrapperSelector = '[id^="launchtip_upsell_wrapper"].luwb_class';
  const productRequests = new Map();
  let activeSignature = '';
  let pendingSignature = '';
  let renderVersion = 0;
  let syncQueued = false;

  function formatMoney(cents) {
    const parsedCents = parseInt(cents, 10);

    if (Number.isNaN(parsedCents)) {
      return '';
    }

    if (typeof Currency !== 'undefined' && typeof Currency.formatMoney === 'function') {
      return Currency.formatMoney(parsedCents, window.theme.moneyFormat);
    }

    return new Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(parsedCents / 100);
  }

  function getProductHandle(link) {
    if (!link) {
      return '';
    }

    const url = new URL(link.href, window.location.origin);
    const match = url.pathname.match(/\/products\/([^/]+)/);

    return match ? decodeURIComponent(match[1]) : '';
  }

  function getOfferProperties(form, nativeWrapper) {
    const properties = {};

    if (form) {
      form.querySelectorAll('input[name^="properties["]').forEach((input) => {
        const match = input.name.match(/^properties\[(.+)\]$/);

        if (match && input.value !== '') {
          properties[match[1]] = input.value;
        }
      });
    }

    if (!properties._sellup_id) {
      const sellupId = nativeWrapper.querySelector('.upsell_onpage_sellup_id');

      if (sellupId && sellupId.value) {
        properties._sellup_id = sellupId.value;
      }
    }

    return properties;
  }

  function getOfferData(offerNode, nativeWrapper) {
    const productLink = offerNode.querySelector('.image a[href*="/products/"], a[href*="/products/"]');
    const form = offerNode.querySelector('form.LaunchTipAddToCartForm, form');
    const variantInput = form && form.querySelector('input[name="id"]');
    const quantityInput = form && form.querySelector('input[name="quantity"]');
    const sellingPlanInput = form && form.querySelector('input[name="selling_plan"]');
    const priceInput = offerNode.querySelector('.main_price');
    const handle = getProductHandle(productLink);
    const variantId = variantInput ? parseInt(variantInput.value, 10) : 0;
    const displayedPrice = priceInput ? parseFloat(priceInput.value) : NaN;

    if (!handle) {
      return null;
    }

    return {
      handle,
      href: productLink.href,
      properties: getOfferProperties(form, nativeWrapper),
      quantity: quantityInput ? parseInt(quantityInput.value, 10) || 1 : 1,
      price: Number.isNaN(displayedPrice) ? null : Math.round(displayedPrice * 100),
      sellingPlan: sellingPlanInput ? sellingPlanInput.value : '',
      variantId
    };
  }

  function requestProduct(handle) {
    if (!productRequests.has(handle)) {
      const rootUrl = window.routes && window.routes.rootUrl ? window.routes.rootUrl : '/';
      const normalizedRootUrl = rootUrl.endsWith('/') ? rootUrl : `${rootUrl}/`;
      const productUrl = `${normalizedRootUrl}products/${encodeURIComponent(handle)}.js`;
      const request = fetch(productUrl, {
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json'
        }
      }).then((response) => {
        if (!response.ok) {
          throw new Error('SellUp product lookup failed');
        }

        return response.json();
      });

      productRequests.set(handle, request);
    }

    return productRequests.get(handle);
  }

  function resolveOffer(offer) {
    return requestProduct(offer.handle).then((product) => {
      const variants = Array.isArray(product.variants) ? product.variants : [];
      const configuredVariant = variants.find((variant) => Number(variant.id) === offer.variantId);
      const variant = configuredVariant && configuredVariant.available
        ? configuredVariant
        : variants.find((candidate) => candidate.available);

      if (!variant) {
        return null;
      }

      return {
        ...offer,
        href: product.url || offer.href,
        image: product.featured_image || (product.images && product.images[0]) || '',
        price: offer.price === null ? Number(variant.price) : offer.price,
        title: product.title,
        variantId: Number(variant.id)
      };
    }).catch(() => null);
  }

  function createSuggestion(offer, pricesIncludeVat) {
    const article = document.createElement('article');
    const thumb = document.createElement('a');
    const body = document.createElement('div');
    const title = document.createElement('a');
    const pricing = document.createElement('div');
    const price = document.createElement('div');
    const subprice = document.createElement('div');
    const exVatPrice = document.createElement('span');
    const add = document.createElement('a');
    const exVatCents = pricesIncludeVat ? Math.round(offer.price / 1.2) : offer.price;

    article.className = 'pdp-suggestion';
    thumb.className = 'pdp-suggestion__thumb';
    thumb.href = offer.href;

    if (offer.image) {
      const image = document.createElement('img');
      image.src = offer.image;
      image.alt = offer.title;
      image.loading = 'lazy';
      thumb.appendChild(image);
    }

    body.className = 'pdp-suggestion__body';
    title.className = 'pdp-suggestion__title';
    title.href = offer.href;
    title.textContent = offer.title;
    body.appendChild(title);

    pricing.className = 'pdp-suggestion__pricing';
    price.className = 'pdp-suggestion__price';
    price.setAttribute('data-pdp-suggestion-price', '');
    price.setAttribute('data-pdp-suggestion-price-cents', String(offer.price));
    price.textContent = formatMoney(offer.price);

    subprice.className = 'pdp-suggestion__subprice';
    exVatPrice.setAttribute('data-pdp-suggestion-ex-vat', '');
    exVatPrice.setAttribute('data-pdp-suggestion-ex-vat-cents', String(exVatCents));
    exVatPrice.textContent = formatMoney(exVatCents);
    subprice.appendChild(exVatPrice);
    subprice.appendChild(document.createTextNode(' Exc VAT'));
    pricing.appendChild(price);
    pricing.appendChild(subprice);

    add.className = 'pdp-suggestion__add';
    add.href = `${window.routes.cartAddUrl}?id=${offer.variantId}&quantity=${offer.quantity}`;
    add.textContent = 'Add';
    add.setAttribute('data-pdp-suggestion-add', '');
    add.setAttribute('data-variant-id', String(offer.variantId));
    add.setAttribute('data-quantity', String(offer.quantity));
    add.setAttribute('data-add-text', 'Add');
    add.setAttribute('data-added-text', 'Added');

    if (offer.sellingPlan) {
      add.setAttribute('data-selling-plan', offer.sellingPlan);
    }

    if (Object.keys(offer.properties).length) {
      add.setAttribute('data-line-properties', JSON.stringify(offer.properties));
    }

    article.appendChild(thumb);
    article.appendChild(body);
    article.appendChild(pricing);
    article.appendChild(add);

    return article;
  }

  function renderOffers(root, offers, signature, version) {
    if (version !== renderVersion) {
      return;
    }

    const pricesIncludeVat = root.getAttribute('data-prices-include-vat') === 'true';
    const fragment = document.createDocumentFragment();

    offers.filter(Boolean).forEach((offer) => {
      fragment.appendChild(createSuggestion(offer, pricesIncludeVat));
    });

    root.querySelectorAll('.pdp-suggestion').forEach((suggestion) => {
      suggestion.remove();
    });

    root.appendChild(fragment);
    root.hidden = !root.querySelector('.pdp-suggestion');
    activeSignature = signature;
    pendingSignature = '';
  }

  function syncSellUpOffers(infoCard, root) {
    const nativeWrapper = infoCard.querySelector(nativeWrapperSelector);

    if (!nativeWrapper) {
      return;
    }

    const offers = Array.from(nativeWrapper.querySelectorAll('.productbox'))
      .map((offerNode) => getOfferData(offerNode, nativeWrapper))
      .filter(Boolean);

    if (!offers.length) {
      return;
    }

    nativeWrapper.classList.add('pdp-sellup-native--processed');
    nativeWrapper.setAttribute('aria-hidden', 'true');
    nativeWrapper.inert = true;

    const signature = offers.map((offer) => {
      return [
        offer.handle,
        offer.variantId,
        offer.quantity,
        offer.price,
        offer.sellingPlan,
        JSON.stringify(offer.properties)
      ].join(':');
    }).join('|');

    if (signature === activeSignature || signature === pendingSignature) {
      return;
    }

    pendingSignature = signature;
    renderVersion += 1;
    const version = renderVersion;

    Promise.all(offers.map(resolveOffer)).then((resolvedOffers) => {
      renderOffers(root, resolvedOffers, signature, version);
    });
  }

  function initSellUpSuggestions() {
    const infoCard = document.querySelector('.pdp-info-card .card__section');
    const root = document.querySelector('[data-pdp-sellup-suggestions]');

    if (!infoCard || !root || !window.fetch) {
      return;
    }

    function queueSync() {
      if (syncQueued) {
        return;
      }

      syncQueued = true;
      requestAnimationFrame(() => {
        syncQueued = false;
        syncSellUpOffers(infoCard, root);
      });
    }

    const observer = new MutationObserver(queueSync);
    observer.observe(infoCard, { childList: true, subtree: true });
    queueSync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSellUpSuggestions);
  } else {
    initSellUpSuggestions();
  }
})();

(function() {
  const productSectionSelector = 'section[data-section-type="product"]';
  const wrapperSelector = '.product-block-list__wrapper';
  const infoCardSelector = '.product-block-list__item--info .pdp-info-card';
  let resizeTimer = null;

  function isDesktopPdpLayout() {
    return !window.matchMedia || window.matchMedia('(min-width: 1000px)').matches;
  }

  function syncProductBlockHeight(root) {
    const scope = root || document;
    const sections = scope.matches && scope.matches(productSectionSelector)
      ? [scope]
      : Array.prototype.slice.call(scope.querySelectorAll(productSectionSelector));

    sections.forEach((section) => {
      const wrapper = section.querySelector(wrapperSelector);
      const infoCard = section.querySelector(infoCardSelector);

      if (!wrapper || !infoCard) {
        return;
      }

      if (!isDesktopPdpLayout()) {
        wrapper.style.minHeight = '';
        return;
      }

      wrapper.style.minHeight = `${Math.ceil(infoCard.getBoundingClientRect().height)}px`;
    });
  }

  function queueProductBlockHeightSync(root) {
    window.requestAnimationFrame(() => {
      syncProductBlockHeight(root);

      window.setTimeout(() => {
        syncProductBlockHeight(root);
      }, 50);
    });
  }

  document.addEventListener('toggle', (event) => {
    if (!event.target || !event.target.matches('.pdp-accordion')) {
      return;
    }

    queueProductBlockHeightSync(event.target.closest(productSectionSelector));
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      queueProductBlockHeightSync(document);
    });
  } else {
    queueProductBlockHeightSync(document);
  }

  window.addEventListener('load', () => {
    queueProductBlockHeightSync(document);
  });

  window.addEventListener('resize', () => {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(() => {
      queueProductBlockHeightSync(document);
    }, 150);
  });

  document.addEventListener('shopify:section:load', (event) => {
    queueProductBlockHeightSync(event.target || document);
  });
})();

(function() {
  const controlSelector = '[data-pdp-gallery-control]';
  const gallerySelector = '.product-gallery';

  function getGalleryCarousel(gallery) {
    return gallery && gallery.querySelector('.product-gallery__carousel');
  }

  function getGalleryFlickity(gallery) {
    const carousel = getGalleryCarousel(gallery);

    if (!carousel || !window.Flickity || typeof window.Flickity.data !== 'function') {
      return null;
    }

    return window.Flickity.data(carousel);
  }

  function getVisibleCarouselItems(gallery) {
    return Array.prototype.filter.call(gallery.querySelectorAll('.product-gallery__carousel-item'), (item) => {
      return !item.classList.contains('is-filtered');
    });
  }

  function getVisibleThumbnails(gallery) {
    return Array.prototype.filter.call(gallery.querySelectorAll('.product-gallery__thumbnail'), (thumbnail) => {
      return !thumbnail.classList.contains('is-filtered');
    });
  }

  function findByMediaId(nodes, mediaId) {
    for (let index = 0; index < nodes.length; index += 1) {
      if (nodes[index].getAttribute('data-media-id') === mediaId) {
        return nodes[index];
      }
    }

    return null;
  }

  function getSelectedThumbnailIndex(thumbnails) {
    for (let index = 0; index < thumbnails.length; index += 1) {
      if (thumbnails[index].classList.contains('is-nav-selected')) {
        return index;
      }
    }

    return -1;
  }

  function scrollSelectedThumbnailIntoView(gallery, thumbnail, animate) {
    const thumbnailList = gallery && gallery.querySelector('.product-gallery__thumbnail-list');

    if (!thumbnailList || !thumbnail) {
      return;
    }

    const scroller = thumbnailList.parentNode;

    if (window.matchMedia && window.matchMedia('(max-width: 999px)').matches && scroller && typeof scroller.scrollTo === 'function') {
      scroller.scrollTo({
        left: thumbnail.offsetLeft - ((scroller.clientWidth - thumbnail.clientWidth) / 2),
        behavior: animate ? 'smooth' : 'auto'
      });
    } else if (typeof thumbnailList.scrollTo === 'function') {
      thumbnailList.scrollTo({
        top: thumbnail.offsetTop - ((thumbnailList.clientHeight - thumbnail.clientHeight) / 2),
        behavior: animate ? 'smooth' : 'auto'
      });
    }
  }

  function selectGalleryMedia(gallery, mediaId, animate) {
    if (!gallery || !mediaId) {
      return false;
    }

    const flickity = getGalleryFlickity(gallery);

    if (flickity) {
      flickity.selectCell(`[data-media-id="${mediaId}"]`);
      return true;
    }

    const carouselItems = Array.prototype.slice.call(gallery.querySelectorAll('.product-gallery__carousel-item'));
    const thumbnails = Array.prototype.slice.call(gallery.querySelectorAll('.product-gallery__thumbnail'));
    const visibleItems = getVisibleCarouselItems(gallery);
    const visibleThumbnails = getVisibleThumbnails(gallery);
    const requestedItem = findByMediaId(carouselItems, mediaId);
    const targetItem = requestedItem && !requestedItem.classList.contains('is-filtered') ? requestedItem : visibleItems[0];
    const targetThumbnail = targetItem ? findByMediaId(thumbnails, targetItem.getAttribute('data-media-id')) : findByMediaId(visibleThumbnails, mediaId);

    if (!targetItem) {
      return false;
    }

    carouselItems.forEach((item) => {
      item.classList.remove('product-gallery__carousel-item--hidden');
      item.classList.toggle('is-selected', item === targetItem);
      item.setAttribute('aria-hidden', item === targetItem ? 'false' : 'true');
    });

    thumbnails.forEach((thumbnail) => {
      thumbnail.classList.toggle('is-nav-selected', thumbnail === targetThumbnail);
    });

    if (targetThumbnail) {
      scrollSelectedThumbnailIntoView(gallery, targetThumbnail, animate);
    }

    return true;
  }

  function syncFallbackGallerySelection(gallery) {
    if (!gallery || getGalleryFlickity(gallery)) {
      return;
    }

    const visibleThumbnails = getVisibleThumbnails(gallery);
    const visibleItems = getVisibleCarouselItems(gallery);
    const selectedThumbnail = visibleThumbnails.find((thumbnail) => {
      return thumbnail.classList.contains('is-nav-selected');
    });
    const selectedItem = visibleItems.find((item) => {
      return item.classList.contains('is-selected');
    });
    const selectedMediaId = selectedThumbnail && selectedThumbnail.getAttribute('data-media-id') ||
      selectedItem && selectedItem.getAttribute('data-media-id') ||
      visibleThumbnails[0] && visibleThumbnails[0].getAttribute('data-media-id') ||
      visibleItems[0] && visibleItems[0].getAttribute('data-media-id');

    if (selectedMediaId) {
      selectGalleryMedia(gallery, selectedMediaId, false);
    }
  }

  function updateGalleryNavigation(gallery) {
    const navigation = gallery && gallery.querySelector('[data-pdp-gallery-navigation]');

    if (!navigation) {
      return;
    }

    navigation.hidden = getVisibleThumbnails(gallery).length < 2;
  }

  function syncGalleryMediaState(sourceGallery, targetGallery) {
    if (!sourceGallery || !targetGallery || sourceGallery === targetGallery) {
      return;
    }

    const sourceItems = Array.prototype.slice.call(sourceGallery.querySelectorAll('.product-gallery__carousel-item'));
    const targetItems = Array.prototype.slice.call(targetGallery.querySelectorAll('.product-gallery__carousel-item'));
    const targetThumbnails = Array.prototype.slice.call(targetGallery.querySelectorAll('.product-gallery__thumbnail'));

    sourceItems.forEach((sourceItem) => {
      const mediaId = sourceItem.getAttribute('data-media-id');
      const targetItem = findByMediaId(targetItems, mediaId);
      const targetThumbnail = findByMediaId(targetThumbnails, mediaId);
      const isFiltered = sourceItem.classList.contains('is-filtered');

      if (targetItem) {
        targetItem.classList.toggle('is-filtered', isFiltered);
      }

      if (targetThumbnail) {
        targetThumbnail.classList.toggle('is-filtered', isFiltered);
      }
    });
  }

  function syncGalleryMediaStates(root) {
    const scope = root || document;
    const galleries = scope.matches && scope.matches(gallerySelector) ? [scope] : Array.prototype.slice.call(scope.querySelectorAll(gallerySelector));
    const sourceGallery = galleries.find((gallery) => {
      return !gallery.closest('.pdp-mobile-gallery-inline');
    }) || galleries[0];

    galleries.forEach((gallery) => {
      syncGalleryMediaState(sourceGallery, gallery);
    });
  }

  function updateGalleryNavigations(root) {
    const scope = root || document;
    const galleries = scope.matches && scope.matches(gallerySelector) ? [scope] : Array.prototype.slice.call(scope.querySelectorAll(gallerySelector));

    galleries.forEach((gallery) => {
      syncFallbackGallerySelection(gallery);
      updateGalleryNavigation(gallery);
    });
  }

  function queueGalleryNavigationUpdate(root) {
    window.requestAnimationFrame(() => {
      updateGalleryNavigations(root || document);
    });
  }

  function selectAdjacentGalleryMedia(gallery, direction) {
    const thumbnails = getVisibleThumbnails(gallery);

    if (thumbnails.length < 2) {
      updateGalleryNavigation(gallery);
      return;
    }

    const selectedIndex = getSelectedThumbnailIndex(thumbnails);
    const offset = direction === 'previous' ? -1 : 1;
    let targetIndex = selectedIndex + offset;

    if (selectedIndex === -1) {
      targetIndex = direction === 'previous' ? thumbnails.length - 1 : 0;
    } else if (targetIndex < 0) {
      targetIndex = thumbnails.length - 1;
    } else if (targetIndex >= thumbnails.length) {
      targetIndex = 0;
    }

    if (!selectGalleryMedia(gallery, thumbnails[targetIndex].getAttribute('data-media-id'), true)) {
      thumbnails[targetIndex].click();
    }

    queueGalleryNavigationUpdate(gallery);
  }

  function bindFallbackSwipe(gallery) {
    if (!gallery || gallery.__pdpGalleryFallbackSwipeBound) {
      return;
    }

    let touchStart = null;

    gallery.__pdpGalleryFallbackSwipeBound = true;

    gallery.addEventListener('touchstart', (event) => {
      if (getGalleryFlickity(gallery) || event.touches.length !== 1) {
        touchStart = null;
        return;
      }

      touchStart = {
        x: event.touches[0].clientX,
        y: event.touches[0].clientY
      };
    }, { passive: true });

    gallery.addEventListener('touchend', (event) => {
      if (!touchStart || getGalleryFlickity(gallery) || !event.changedTouches.length) {
        touchStart = null;
        return;
      }

      const deltaX = event.changedTouches[0].clientX - touchStart.x;
      const deltaY = event.changedTouches[0].clientY - touchStart.y;

      touchStart = null;

      if (Math.abs(deltaX) < 40 || Math.abs(deltaX) < Math.abs(deltaY) * 1.4) {
        return;
      }

      selectAdjacentGalleryMedia(gallery, deltaX < 0 ? 'next' : 'previous');
    }, { passive: true });
  }

  function bindFallbackSwipes(root) {
    const scope = root || document;
    const galleries = scope.matches && scope.matches(gallerySelector) ? [scope] : Array.prototype.slice.call(scope.querySelectorAll(gallerySelector));

    galleries.forEach((gallery) => {
      bindFallbackSwipe(gallery);
    });
  }

  /*
   * A third-party capture listener can stop product gallery clicks before they
   * reach Warehouse's native media handler. Keep propagation available only
   * for gallery controls so models, videos and image thumbnails are activated
   * by the theme as intended.
   */
  window.addEventListener('click', (event) => {
    const galleryTarget = event.target && event.target.closest ?
      event.target.closest(`${controlSelector}, .product-gallery__thumbnail`) :
      null;

    if (!galleryTarget || !galleryTarget.closest(gallerySelector)) {
      return;
    }

    Object.defineProperty(event, 'stopPropagation', {
      configurable: true,
      value: () => {}
    });

    Object.defineProperty(event, 'stopImmediatePropagation', {
      configurable: true,
      value: () => {}
    });
  }, true);

  document.addEventListener('click', (event) => {
    const control = event.target && event.target.closest ? event.target.closest(controlSelector) : null;

    if (!control) {
      return;
    }

    const gallery = control.closest(gallerySelector);

    if (!gallery) {
      return;
    }

    event.preventDefault();
    selectAdjacentGalleryMedia(gallery, control.getAttribute('data-pdp-gallery-control'));
  });

  document.addEventListener('click', (event) => {
    const thumbnail = event.target && event.target.closest ? event.target.closest('.product-gallery__thumbnail') : null;

    if (!thumbnail) {
      return;
    }

    const gallery = thumbnail.closest(gallerySelector);

    if (!gallery) {
      return;
    }

    if (!getGalleryFlickity(gallery)) {
      event.preventDefault();
      selectGalleryMedia(gallery, thumbnail.getAttribute('data-media-id'), true);
    }

    queueGalleryNavigationUpdate(gallery);
  });

  document.addEventListener('variant:changed', (event) => {
    const sectionEl = event.target && event.target.closest ? event.target.closest('[data-section-type="product"]') : null;
    const variant = event.detail && event.detail.variant;
    const featuredMediaId = variant && variant.featured_media && String(variant.featured_media.id);

    syncGalleryMediaStates(sectionEl || document);

    if (featuredMediaId) {
      const galleries = sectionEl ? Array.prototype.slice.call(sectionEl.querySelectorAll(gallerySelector)) : Array.prototype.slice.call(document.querySelectorAll(gallerySelector));

      galleries.forEach((gallery) => {
        selectGalleryMedia(gallery, featuredMediaId, true);
      });
    }

    queueGalleryNavigationUpdate(sectionEl || document);
  });

  document.addEventListener('shopify:section:load', (event) => {
    bindFallbackSwipes(event.target || document);
    queueGalleryNavigationUpdate(event.target || document);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      syncGalleryMediaStates(document);
      bindFallbackSwipes(document);
      updateGalleryNavigations(document);
    });
  } else {
    syncGalleryMediaStates(document);
    bindFallbackSwipes(document);
    updateGalleryNavigations(document);
  }
})();

/* updating quantity controls */

const stickyAtcSelect = document.querySelector('.sticky-atc__quantity select');
const stickyAtcQuantity = document.querySelector('.sticky-atc__quantity');
const stickyAtcQuantityValue = document.querySelector('[data-sticky-quantity-display]');
const stickyAtcButton = document.querySelector('.sticky-atc__button');

function getPdpQuantityField() {
  return document.querySelector('.pdp-purchase__quantity .product-form__quantity');
}

function isPdpQuantityHidden(quantityField) {
  const quantityWrapper = quantityField && quantityField.closest('.pdp-purchase__quantity');

  return !quantityField || Boolean(quantityWrapper && quantityWrapper.hidden);
}

function getPdpSubmitButton() {
  return document.querySelector('.pdp-purchase-form .product-form__add-button');
}

function getStickyAtcQuantityValue(value) {
  const parsedValue = parseInt(value, 10);

  if (Number.isNaN(parsedValue) || parsedValue < 1) {
    return '1';
  }

  return parsedValue >= 10 ? '10' : String(parsedValue);
}

function syncStickyAtcQuantityDisplay() {
  if (!stickyAtcSelect || !stickyAtcQuantityValue) {
    return;
  }

  const option = stickyAtcSelect.options[stickyAtcSelect.selectedIndex] || stickyAtcSelect.options[0];
  stickyAtcQuantityValue.textContent = option ? option.textContent.trim().replace(/\+$/, '') : '';
}

function syncStickyAtcQuantity(value) {
  if (!stickyAtcSelect) {
    return;
  }

  stickyAtcSelect.value = getStickyAtcQuantityValue(value);
  syncStickyAtcQuantityDisplay();
}

function syncStickyAtcQuantityOptions() {
  const quantityField = getPdpQuantityField();

  if (!stickyAtcSelect || !quantityField || quantityField.tagName !== 'SELECT') {
    if (stickyAtcQuantity) {
      stickyAtcQuantity.hidden = true;
    }

    return;
  }

  if (stickyAtcQuantity) {
    stickyAtcQuantity.hidden = isPdpQuantityHidden(quantityField);
  }

  const currentValue = stickyAtcSelect.value || quantityField.value;
  stickyAtcSelect.innerHTML = '';

  Array.prototype.forEach.call(quantityField.options, (option) => {
    stickyAtcSelect.appendChild(new Option(option.textContent, option.value, false, option.selected));
  });

  stickyAtcSelect.disabled = quantityField.disabled;
  stickyAtcSelect.value = currentValue;

  if (stickyAtcSelect.value !== currentValue) {
    stickyAtcSelect.value = quantityField.value;
  }

  syncStickyAtcQuantityDisplay();
}

function syncStickyAtcButton() {
  const sourceButton = getPdpSubmitButton();
  const quantityField = getPdpQuantityField();

  if (!stickyAtcButton || !sourceButton) {
    return;
  }

  const sourceLabel = sourceButton.querySelector('.pdp-purchase__button-label');
  const stickyLabel = stickyAtcButton.querySelector('.sticky-atc__button-label');
  const stickyIcon = stickyAtcButton.querySelector('.sticky-atc__button-icon');
  const label = (sourceLabel ? sourceLabel.textContent : sourceButton.textContent).trim();
  const isDisabled = sourceButton.disabled || sourceButton.classList.contains('button--disabled');

  stickyAtcButton.disabled = isDisabled;
  stickyAtcButton.classList.toggle('button--disabled', isDisabled);
  stickyAtcButton.classList.toggle('button--primary', !isDisabled);

  if (stickyLabel && label) {
    stickyLabel.textContent = label;
  }

  if (stickyIcon) {
    stickyIcon.hidden = false;
  }

  if (stickyAtcQuantity) {
    stickyAtcQuantity.hidden = isDisabled || isPdpQuantityHidden(quantityField);
  }
}

function syncPdpQuantity(value) {
  const quantityField = getPdpQuantityField();

  if (!quantityField) {
    return;
  }

  quantityField.value = value;
  quantityField.dispatchEvent(new Event('input', { bubbles: true }));
  quantityField.dispatchEvent(new Event('change', { bubbles: true }));
}

if (stickyAtcSelect) {
  const initialQuantityField = getPdpQuantityField();

  if (initialQuantityField) {
    syncStickyAtcQuantityOptions();
    syncStickyAtcQuantity(initialQuantityField.value);

    if (initialQuantityField.tagName === 'SELECT') {
      const quantityObserver = new MutationObserver(() => {
        syncStickyAtcQuantityOptions();
      });

      quantityObserver.observe(initialQuantityField, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['disabled']
      });
    }
  }

  stickyAtcSelect.addEventListener('change', function() {
    syncPdpQuantity(this.value);
  });

  document.addEventListener('input', function(event) {
    if (!event.target.matches('.pdp-purchase__quantity .product-form__quantity')) {
      return;
    }

    syncStickyAtcQuantity(event.target.value);
  });

  document.addEventListener('change', function(event) {
    if (!event.target.matches('.pdp-purchase__quantity .product-form__quantity')) {
      return;
    }

    syncStickyAtcQuantity(event.target.value);
  });
}

/* atc action */

if (stickyAtcButton) {
  syncStickyAtcButton();

  const sourceButton = getPdpSubmitButton();

  if (sourceButton) {
    const buttonObserver = new MutationObserver(() => {
      syncStickyAtcButton();
    });

    buttonObserver.observe(sourceButton, {
      childList: true,
      subtree: true,
      characterData: true,
      attributes: true,
      attributeFilter: ['class', 'disabled', 'data-action']
    });
  }

  document.addEventListener('variant:changed', function() {
    syncStickyAtcButton();
    syncStickyAtcQuantityOptions();
  });

  stickyAtcButton.addEventListener('click', function() {
    const formSubmitButton = getPdpSubmitButton();

    if (formSubmitButton && !formSubmitButton.disabled) {
      formSubmitButton.click();
    }
  });
}

window.addEventListener('click', function(event) {
  const target = event.target && event.target.closest ? event.target.closest('[data-pdp-suggestion-add]') : null;

  if (!target) {
    return;
  }

  event.stopPropagation();

  if (target.classList.contains('pdp-suggestion__add--added')) {
    event.preventDefault();
    return;
  }

  if (!window.fetch || !window.routes || !window.routes.cartAddUrl) {
    return;
  }

  const variantId = parseInt(target.getAttribute('data-variant-id'), 10);
  const quantity = parseInt(target.getAttribute('data-quantity') || '1', 10);
  const sellingPlan = target.getAttribute('data-selling-plan');
  let properties = {};

  if (!variantId) {
    return;
  }

  try {
    properties = JSON.parse(target.getAttribute('data-line-properties') || '{}');
  } catch (error) {
    properties = {};
  }

  event.preventDefault();
  target.classList.add('pdp-suggestion__add--loading');

  const lineItem = {
    id: variantId,
    quantity: Number.isNaN(quantity) ? 1 : quantity
  };

  if (sellingPlan) {
    lineItem.selling_plan = sellingPlan;
  }

  if (Object.keys(properties).length) {
    lineItem.properties = properties;
  }

  fetch(`${window.routes.cartAddUrl}.js`, {
    body: JSON.stringify(lineItem),
    credentials: 'same-origin',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    }
  }).then((response) => {
    if (!response.ok) {
      throw new Error('Suggestion add failed');
    }

    return response.json();
  }).then((item) => {
    const addedText = target.getAttribute('data-added-text') || 'Added';
    target.textContent = addedText;
    target.classList.remove('pdp-suggestion__add--loading');
    target.classList.add('pdp-suggestion__add--added');
    target.setAttribute('aria-label', addedText);
    target.dispatchEvent(new CustomEvent('product:added', {
      bubbles: true,
      detail: {
        variant: item,
        quantity: Number.isNaN(quantity) ? 1 : quantity
      }
    }));
  }).catch(() => {
    window.location.href = target.href;
  });
}, true);

(function() {
  const trackSelector = '.pdp-review-band__carousel .jdgm-carousel__item-wrapper, .pdp-review-cards';
  let resizeTimer = null;
  let observerTimer = null;

  function getTicker(track) {
    if (!track) {
      return null;
    }

    return track.closest('.pdp-review-band');
  }

  function getTickerViewport(track) {
    if (!track) {
      return null;
    }

    return track.closest('.pdp-review-band__carousel') || track.closest('.pdp-review-band') || track.parentElement;
  }

  function setTickerTransform(track, value) {
    track.style.setProperty('transform', value, 'important');
  }

  function configureTickerViewport(track) {
    const outer = track.closest('.pdp-review-band__carousel');
    const widget = track.closest('.jdgm-carousel');
    const container = track.closest('.jdgm-carousel__item-container');

    [widget, container].forEach((node) => {
      if (!node) {
        return;
      }

      node.style.setProperty('overflow', 'hidden', 'important');
      node.style.setProperty('overflow-x', 'hidden', 'important');
      node.style.setProperty('overflow-y', 'hidden', 'important');
    });

    if (outer) {
      outer.style.setProperty('overflow', 'visible', 'important');
    }
  }

  function getOriginalItems(track) {
    return Array.prototype.filter.call(track.children, (child) => {
      return child.nodeType === 1 && child.getAttribute('data-pdp-review-clone') !== 'true';
    });
  }

  function removeTickerClones(track) {
    const clones = track.querySelectorAll('[data-pdp-review-clone="true"]');

    clones.forEach((clone) => {
      clone.remove();
    });
  }

  function setupReviewTicker(track) {
    if (!track) {
      return;
    }

    if (track.__pdpReviewTicker) {
      track.__pdpReviewTicker.refresh();
      return;
    }

    const ticker = getTicker(track);
    const parsedSpeed = parseFloat((ticker && ticker.getAttribute('data-review-ticker-speed')) || '30');
    const speed = Number.isFinite(parsedSpeed) && parsedSpeed > 0 ? parsedSpeed : 30;
    const direction = (ticker && ticker.getAttribute('data-review-ticker-direction')) || 'left';
    let baseWidth = 0;
    let offset = 0;
    let rafId = null;
    let lastTime = null;
    let destroyed = false;

    function cloneSet(items) {
      items.forEach((item) => {
        const clone = item.cloneNode(true);

        clone.setAttribute('data-pdp-review-clone', 'true');
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      });
    }

    function stop() {
      if (rafId) {
        window.cancelAnimationFrame(rafId);
      }

      rafId = null;
      lastTime = null;
    }

    function step(timestamp) {
      if (destroyed || !track.isConnected) {
        destroy();
        return;
      }

      if (!lastTime) {
        lastTime = timestamp;
      }

      const delta = (timestamp - lastTime) / 1000;
      const distance = speed * delta;

      lastTime = timestamp;

      if (direction === 'right') {
        offset += distance;

        if (offset >= 0) {
          offset -= baseWidth;
        }
      } else {
        offset -= distance;

        if (offset <= -baseWidth) {
          offset += baseWidth;
        }
      }

      setTickerTransform(track, `translate3d(${offset}px, 0, 0)`);
      rafId = window.requestAnimationFrame(step);
    }

    function refresh() {
      const originalItems = getOriginalItems(track);
      const viewport = getTickerViewport(track);

      stop();
      track.classList.remove('pdp-review-ticker');
      setTickerTransform(track, 'translate3d(0, 0, 0)');
      removeTickerClones(track);
      configureTickerViewport(track);

      if (destroyed || originalItems.length < 2) {
        return;
      }

      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
      }

      baseWidth = track.scrollWidth;

      if (!baseWidth) {
        return;
      }

      const minWidth = (viewport ? viewport.clientWidth : window.innerWidth || 0) + baseWidth;
      let cloneSets = 0;

      while (track.scrollWidth < minWidth && cloneSets < 20) {
        cloneSet(originalItems);
        cloneSets += 1;
      }

      offset = direction === 'right' ? -baseWidth : 0;
      track.classList.add('pdp-review-ticker');
      setTickerTransform(track, `translate3d(${offset}px, 0, 0)`);
      rafId = window.requestAnimationFrame(step);
    }

    function destroy() {
      destroyed = true;
      stop();
      track.classList.remove('pdp-review-ticker');
      setTickerTransform(track, 'translate3d(0, 0, 0)');
      removeTickerClones(track);
      delete track.__pdpReviewTicker;
    }

    track.__pdpReviewTicker = {
      refresh,
      destroy
    };

    refresh();
  }

  function initReviewTickers(root) {
    const scope = root || document;
    const tracks = scope.matches && scope.matches(trackSelector) ? [scope] : Array.prototype.slice.call(scope.querySelectorAll(trackSelector));

    tracks.forEach((track) => {
      setupReviewTicker(track);
    });
  }

  function queueReviewTickerInit(root) {
    window.requestAnimationFrame(() => {
      initReviewTickers(root || document);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      queueReviewTickerInit(document);
    });
  } else {
    queueReviewTickerInit(document);
  }

  window.addEventListener('load', () => {
    queueReviewTickerInit(document);
  });

  window.addEventListener('resize', () => {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(() => {
      queueReviewTickerInit(document);
    }, 150);
  });

  document.addEventListener('shopify:section:load', (event) => {
    queueReviewTickerInit(event.target || document);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    const section = event.target || document;
    const tracks = Array.prototype.slice.call(section.querySelectorAll(trackSelector));

    tracks.forEach((track) => {
      if (track.__pdpReviewTicker) {
        track.__pdpReviewTicker.destroy();
      }
    });
  });

  if (window.MutationObserver) {
    const observer = new MutationObserver((mutations) => {
      const shouldInit = mutations.some((mutation) => {
        return Array.prototype.some.call(mutation.addedNodes, (node) => {
          return node.nodeType === 1 && node.getAttribute('data-pdp-review-clone') !== 'true' && (
            node.matches('.pdp-review-band, .jdgm-carousel__item-wrapper, .pdp-review-cards, .jdgm-carousel-item, .pdp-review-card') ||
            node.querySelector('.pdp-review-band, .jdgm-carousel__item-wrapper, .pdp-review-cards, .jdgm-carousel-item, .pdp-review-card')
          );
        });
      });

      if (!shouldInit) {
        return;
      }

      window.clearTimeout(observerTimer);
      observerTimer = window.setTimeout(() => {
        queueReviewTickerInit(document);
      }, 100);
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
})();
